// ** Icons Import
import {BookOpen, FolderPlus, List} from 'react-feather'

export default [
    {
        header: 'navigation.reservation',
        action: 'ROLE_CUSTOMER',
        resource: 'IS_GRANTED'
    },
    {
        id: 'reservation-new-reservation',
        title: 'navigation.new_reservation',
        icon: <FolderPlus size={20}/>,
        navLink: '/reservation/new',
        action: 'ROLE_CUSTOMER',
        resource: 'IS_GRANTED'
    },
    {
        id: 'reservation-reservation-list',
        title: 'navigation.user_reservation_list',
        icon: <BookOpen size={20}/>,
        navLink: '/reservation/list',
        action: 'ROLE_CUSTOMER',
        resource: 'IS_GRANTED'
    },
    {
        header: 'navigation.reservation_management',
        action: 'ROLE_RESERVATION_MANAGEMENT_',
        resource: 'IS_GRANTED'
    },
    {
        id: 'reservation-management-list',
        title: 'navigation.reservation_list',
        icon: <List size={20}/>,
        navLink: '/reservation/management/list',
        action: 'ROLE_RESERVATION_MANAGEMENT_LIST',
        resource: 'IS_GRANTED'
    }
]